import { ApolloError } from 'apollo-client';

import { formatGqlError } from '../../utils/helpers';

const DUPLICATE_CELL_NUMBER_MESSAGE = 'A stakeholder with this cell number already exists';

export function formatStakeholderGqlError(error: ApolloError): string {
  const message = formatGqlError(error);

  if (
    message.includes(DUPLICATE_CELL_NUMBER_MESSAGE) ||
    (message.includes('Unique constraint failed') && message.includes('cellNumber'))
  ) {
    return DUPLICATE_CELL_NUMBER_MESSAGE;
  }

  return message;
}



// WEBPACK FOOTER //
// ./src/forms/stakeholders/stakeholderError.ts